import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import { BulletHistoryItem } from "@/types/BulletHistoryItem";

interface BulletHistoryState { items: BulletHistoryItem[]; isLoading: boolean; }
const initialState: BulletHistoryState = { items: [], isLoading: false };

export const getBulletHistory = createAsyncThunk(
  "bulletHistory/getBulletHistory",
  async ({ address }: { address: string }) => {
    const response = await axios.get(`${SERVER_URL}/profile/bulletHistory/${address}`);
    return response.data;
  }
);

const bulletHistorySlice = createSlice({
  name: "bulletHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBulletHistory.pending, (state) => { state.isLoading = true; })
      .addCase(getBulletHistory.fulfilled, (state, { payload }) => { state.items = payload; state.isLoading = false; })
      .addCase(getBulletHistory.rejected, (state) => { state.isLoading = false; });
  },
});

export default bulletHistorySlice.reducer;
